import React from 'react';
import {connect} from "react-redux";
import PaymentMethodDto from '../../model/payment/PaymentMethodDto'
import {updatePaymentMethod, openModal_2, closeModalCB, closeModalCB_2,closeModalCB_3, closeModal,closeModal_2,openModalCB, createProcedure} from "./../../actions/CustomerActions"
import SignDocument from "./../elements/SignDocument.jsx";
import LocalStorageService from '../../services/LocalStorageService';

import {
  withStyles,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem} from '@material-ui/core';

  import styles from "./customMaterialUIStyle";

@connect(store => {
	return {
  customer: store.customer.customer,
  validateIbanAndBic: store.customer.status || "",
  messageError: store.customer.message || "",
  showDocumentSignModal:store.customer.showDocumentSignModal,
  openRedirect: store.customer.openRedirect,
  messages: store.messages.messages,
  showModalCB:  store.customer.showModalCB,
}})

class Ribform extends React.Component {
  state = {
    customerData: {},
    customerDataUpadated:false,
    oldPayementMethod: {}
  };

  componentDidUpdate(){
    const {validateIbanAndBic, paymentMethod} = this.props;
    const {oldPayementMethod} = this.state;
    if (validateIbanAndBic === "FAIL"){
      this.props.dispatch(openModal_2());
      this.props.dispatch(openModalCB());
    }
}
  handleClose = () => {
    this.props.dispatch(closeModalCB());
    this.props.dispatch(closeModal());
    this.props.dispatch(closeModalCB_2());
    this.props.dispatch(closeModalCB_3());
    this.props.dispatch(closeModal_2());
  };

  handleCloseRedirect = () => {
    this.props.dispatch(closeRedirectModal());
  };

  handleChange = (event) => {
    event && event.preventDefault();
    const {paymentMethod} = this.props;
    let {customerData, customerDataUpadated} = this.state;
    if (customerDataUpadated === false) {
      customerData = new PaymentMethodDto(paymentMethod);
    };
    const bankCoordinates = !!customerData && customerData.bankCoordinates || {};
    const fieldName = !!event && !!event.target && event.target.name;
    bankCoordinates[fieldName] =  event.target.value;
    bankCoordinates["iban"] = bankCoordinates["iban1"] + bankCoordinates["iban2"] + bankCoordinates["iban3"] + bankCoordinates["iban4"]
    + bankCoordinates["iban5"] + bankCoordinates["iban6"] + bankCoordinates["iban7"];
    bankCoordinates["accountOwner"] =   bankCoordinates["accountOwner"];
    this.setState({customerData:customerData, customerDataUpadated: true});
  };

  onSbmit = (e) => {
      const {customerData} = this.state;
      const paymentMethod = customerData;
      const {subscription, dispatch, offer} = this.props;
      const userAccount= LocalStorageService.getCurrentContact();
      dispatch(updatePaymentMethod(paymentMethod, offer, subscription, userAccount));
  };

render() {
  const {validateIbanAndBic,userAccount,open,customerAccount, paymentMethod,messages,classes,showDocumentSignModal } = this.props;
  const {bankCoordinates} = paymentMethod || {};
  const {iban} = bankCoordinates || "";
  const lastName = !!bankCoordinates && paymentMethod.bankCoordinates.accountOwner.split(" ")[0];
  const firstName =  !!bankCoordinates && bankCoordinates.accountOwner.split(" ")[1];

  return (
    <React.Fragment>
    <Dialog
      open={open && !showDocumentSignModal}
      onClose={this.handleClose}
      aria-labelledby="simple-dialog-title"
      maxWidth={false}
      BackdropProps={{
        classes: {
         root: classes.root
        }
       }
      }
      PaperProps ={{
        classes: {
         root: classes.paper
        }
      }}
      >
        <div className={classes.dialogWindow}>
          <DialogTitle className={classes.dialogTitle} id="form-dialog-title">{messages["common.label.update.cb"]}</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Grid fullwidth="true" className={classes.labelWarning}>
              <label className={classes.label}>{this.props.messageError}</label>
            </Grid>
            <Grid container spacing={2}>
              <Grid>
                <label className={classes.label}>{messages["common.label.holder"]}</label>
                <TextField
                  className={classes.textField}
                  inputRef={el => this.firstName = el}
                  name="accountOwner"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{'font-weight':"blod", fontSize:"2rem" }}
                />
              </Grid>
              {/* <TextField
                className={classes.textField}
                margin="dense"
                inputRef={value => this.lastName = value}
                name="accountOwnerLastName"
                placeholder={"Nom"}
                onChange={this.handleChange}
                InputLabelProps={{'font-weight':"blod", fontSize:"2rem" }}
              /> */}
              <Grid>
                <label className={classes.label} >{messages["common.label.iban"]}</label>
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban1"
                  margin="dense"

                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true, maxLength:"4"}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban2"
                  margin="dense"

                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban3"
                  margin="dense"

                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban4"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban5"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban6"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"4"}}
                />
                <TextField
                  autoFocus
                  className={classes.textFieldless}
                  inputRef={value => this.iban = value}
                  name="iban7"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{shrink: true,}}
                  inputProps={{maxLength:"3"}}
                />
              </Grid>
              {/* <Grid>
                <label className={classes.label}>{messages["common.label.bic"]}</label>
                <TextField
                  autoFocus
                  className={classes.textField}
                  inputRef={value => this.bic = value}
                  name="bic"
                  margin="dense"
                  onChange={this.handleChange}
                  InputLabelProps={{'font-weight':"blod", fontSize:"2rem" }}
                  inputProps={{maxLength:"11"}}
                />
              </Grid> */}
            </Grid>
            <Grid>
              {/* <label className={classes.label}>{messages["common.label.reference.mandat"]} : </label> */}
            </Grid>
          </DialogContent>
          <DialogActions className={classes.justifyContent}>
            <Button onClick={this.handleClose} variant="contained" className={`${classes.button} ${classes.secondaryButton}`}>
                  {messages["common.button.cancel"]}
            </Button>
            <Button onClick={this.onSbmit} variant="contained" className={`${classes.button} ${classes.primaryButton}`}>
                  {messages["common.button.update.dialog"]}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
      <SignDocument validateIbanAndBic={validateIbanAndBic} paymentMethod={paymentMethod} userAccount={userAccount} customerAccount={customerAccount}/>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Ribform);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/Ribform.jsx